import getUrlForEnv, {services} from "@irati/utils/endpoints/getUrlForEnv"

const endpoints = {
  users: () => getUrlForEnv(services.IDENTITY_SERVICE, "/v2/users"),
  unAuthedUser: (uuid: string) => getUrlForEnv(services.IDENTITY_SERVICE, `/v2/users/${uuid}/unauth`),
  teams: (tenantId?: string) => getUrlForEnv(services.IDENTITY_SERVICE, `/v2/tenants/${tenantId}/teams`),
  tenants: () => getUrlForEnv(services.IDENTITY_SERVICE, "/v2/tenants"),
  subdomainHistory: (tenantId: string) => getUrlForEnv(services.IDENTITY_SERVICE, `/v2/tenants/${tenantId}/subdomains`)
}

export default endpoints
